import React from 'react';
import { problem } from '../data/content';

export default function Problem() {
  return (
    <section id="problem" className="relative py-24 lg:py-36 bg-[#E3DBD1] border-t border-[#d9d2ca]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4" data-reveal>
          <p className="sec-num text-sm tracking-[0.3em] uppercase">/ 01</p>
          <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]">{problem.eyebrow}</p>
        </div>
        <div className="lg:col-span-8">
          <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[60px] leading-[1.05] tracking-[-0.015em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '120ms' }}>
            A business cannot scale <span className="italic text-[#B5876C]">one founder-led deal</span> at a time.
          </h2>
          <p className="mt-10 text-lg lg:text-xl leading-relaxed text-[#4a463f] max-w-3xl font-light" data-reveal style={{ '--reveal-delay': '220ms' }}>
            {problem.body}
          </p>
        </div>
      </div>
    </section>
  );
}
